import { useCallback } from 'react'
import { useTheme } from '@mui/material/styles'
import type { EventInviteStatus } from '../types'

export let STATUS_LABELS: Record<EventInviteStatus, string> = {
  invited: 'Pending RSVP',
  accepted: 'Accepted',
  waitlisted: 'Waitlisted',
  declined: 'Declined',
  attended: 'Attended',
}

export let useStatusChipColor = () => {
  let theme = useTheme()
  return useCallback(
    (status: EventInviteStatus | null): string => {
      if (!status) return 'rgba(255,255,255,.3)'
      let map: Record<EventInviteStatus, string> = {
        invited: theme.palette.analyticsColors?.recordedCourses ?? '#B39DDB',
        accepted: theme.palette.info.main,
        waitlisted: theme.palette.warning.main,
        declined: theme.palette.error.main,
        attended: theme.palette.success.main,
      }
      return map[status]
    },
    [theme],
  )
}
